import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { v4 as uuid } from "uuid";
function AuthVideo() {
  const { book, videoId } = useParams();
  const [element, setElement] = useState(
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "45px", height: "calc(100vh - 165px)", width: "100%", backgroundColor: "#000", color: "#fff" }}>
      <h1>Please wait...</h1>
    </div>
  );
  const [cred, setCred] = useState();
  const [isVerified, setVerified] = useState(false);
  const [code, setCode] = useState();
  useEffect(() => {
    const API = `https://video-api.vkpublications.com`;
    let temp = {};

    if (localStorage.getItem("cred") !== null) {
      let device;
      new Promise((res, rej) => {
        temp = JSON.parse(localStorage.getItem("cred"));
        res(temp);
      })
        .then((t) => {
          device = t?.device || uuid();
        })
        .then(async () => {
          const response = await fetch(`${API}/master/user-device/${device}`, { method: "GET" });
          if (response.ok) {
            await response.json().then((json) => {
              temp.name = json.name;
              temp.email = json.email;
              temp.user = json.user_id;
              temp.device = device;
              setCred(temp);
              localStorage.setItem("cred", JSON.stringify(temp));

              const key = temp?.devices?.filter((f) => f.key === book)[0];
              if (key?.value) {
                const getVideo = async () => {
                  const body = { user_id: temp?.user, device_id: temp?.device, book_name: book, content_id: videoId, access_code: key.value };
                  const video = await fetch(`https://video-api.vkpublications.com/master/access`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
                  if (video.ok) {
                    await video.json().then((vdo) => {
                      setVerified(true);
                      setElement(
                        <div className="video-container">
                          <iframe className="video-iframe" src={`https://player.vimeo.com/video/${vdo.content?.content}?autoplay=1&loop=1`} title="VK Global Video Player" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen data-ready="true" />
                        </div>
                      );
                    });
                  }
                };
                getVideo();
              }
            });
          } else {
            temp.device = device;
            setCred(temp);
            setVerified(false);
            localStorage.setItem("cred", JSON.stringify(temp));
          }
        });
    } else {
      temp.device = uuid();
      setCred(temp);
      setVerified(false);
      localStorage.setItem("cred", JSON.stringify(temp));
    }
  }, [videoId, book]);
  const checkUser = async () => {
    const body = { join_date: "2025-01-01", name: cred?.name?.trim(), email: cred?.email?.toLowerCase().trim() };
    const response = await fetch(`https://video-api.vkpublications.com/master/user`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
    if (response.ok) {
      await response.json().then((json) => {
        const temp = { ...cred, name: json.name, email: json.email, user: json.user_id };
        setCred(temp);
        localStorage.setItem("cred", JSON.stringify(temp));
      });
    }
  };
  const checkAccess = async () => {
    const body = { user_id: cred?.user, device_id: cred?.device, book_name: book, content_id: videoId, access_code: code.code };
    const response = await fetch(`https://video-api.vkpublications.com/master/access`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
    if (response.ok) {
      await response.json().then((json) => {
        const devices = [...(cred.devices || [])];
        devices.push({ key: book, value: code.code, validity: new Date(json.device_info.validity).valueOf() });
        const temp = { ...cred, devices: devices };
        setCred(temp);
        localStorage.setItem("cred", JSON.stringify(temp));
        setVerified(true);
        setElement(
          <div className="video-container">
            <iframe className="video-iframe" src={`https://player.vimeo.com/video/${json.content?.content}?autoplay=1&loop=1`} title="VK Global Video Player" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen data-ready="true" />
          </div>
        );
      });
    }
  };
  return isVerified ? (
    element
  ) : (
    <div className="modal-wrapper">
      <div className="modal">
        <h2>Welcome</h2>
        <hr />
        {!cred?.user ? (
          <>
            <h4 style={{ fontWeight: 300 }}>Please provide your name and email address</h4>
            <div className="input-group" style={{ marginBottom: 12 }}>
              <input type="text" maxLength={100} minLength={3} name="name" required onChange={(e) => setCred({ ...cred, name: e.target.value })} />
              <label htmlFor="name">Name</label>
            </div>
            <div className="input-group" style={{ marginBottom: 12 }}>
              <input type="email" maxLength={100} minLength={3} name="email" required onChange={(e) => setCred({ ...cred, email: e.target.value })} />
              <label htmlFor="email">Email Address</label>
            </div>
            <div>
              <button
                className="btn"
                onClick={() => {
                  checkUser();
                }}
              >
                Next
                <div className="icon">
                  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" fill="currentColor"></path>
                  </svg>
                </div>
              </button>
            </div>
          </>
        ) : (
          <>
            <h4 style={{ fontWeight: 300 }}>Please provide your access code</h4>
            <div className="input-group" style={{ marginBottom: 12 }}>
              <input type="text" maxLength={100} minLength={3} value={code?.code} name="code" required onChange={(e) => setCode({ code: e.target.value })} />
              <label htmlFor="code">Access Code</label>
            </div>
            {code?.error && <div style={{ borderRadius: 4, padding: "2px 3px", backgroundColor: "red", color: "white" }}>{code.error}</div>}
            <div>
              <button
                className="btn"
                onClick={() => {
                  checkAccess();
                }}
              >
                Submit
                <div className="icon">
                  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" fill="currentColor"></path>
                  </svg>
                </div>
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default AuthVideo;
